export const BREAKPOINTS = {
    mobile: 480,
    tablet: 768,
    desktop: 1025
};